import React from "react";
import { Button } from "react-bootstrap";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCartShopping} from "@fortawesome/pro-light-svg-icons";
import { useAuth } from "../../../../auth/useAuth";
import CatalogContext from "../../../../contexts/CatalogContext";
import ProposalIndicator from "./ProposalIndicator";

import "./ProposalButton.scss";

function ProposalButton({ onClick, foregroundColor }) {
	const { currentUser } = useAuth();
	const [catalog] = React.useContext(CatalogContext);

	if (!currentUser || !catalog.options?.proposals?.access) {
		return (<></>);
	}

	return (
		<div data-component="ProposalButton">
			<Button
				type="button"
				variant="link"
				className="proposal-nav"
				onClick={e => onClick?.(e)}
			>
				<FontAwesomeIcon
					icon={faCartShopping}
					className="proposal-nav-icon"
				/>
				<ProposalIndicator />
			</Button>
		</div>
	);
}

export default ProposalButton;
